




















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetTemNum } from "@/request/common";
@Component({})
export default class Name extends Vue {
  @Prop()
  private IfShow: any;
  @Watch("IfShow", { immediate: true })
  private IfShowChange() {
    this.getNum();
    this.ifVisible = this.IfShow;
    this.data = [];
  }
  private ifVisible: any = false;
  private data: any = [];
  private numData: any = {};
  private typeOption: any = ["单选", "多选", "判断", "填空"];
  private getPlaceholderText(item: any) {
    if (!item["类别"]) {
      return "抽取数量";
    } else {
      if (
        item["类别"] == "四诊" &&
        item["题目类型"] &&
        item["题目类型"].length > 0
      ) {
        let num: any = 0;
        item["题目类型"].forEach((ele: any) => {
          num += this.numData["四诊" + ele];
        });
        return "最大" + num;
      } else {
        return "最大" + (this.numData[item["类别"]] || 0);
      }
    }
  }
  private itemChange(item: any) {
    delete item["数量"];
  }
  private addOne() {
    this.data.push({
      题目类型: [],
    });
  }
  private delOne(index: any) {
    this.data.splice(index, 1);
  }
  private cancel() {
    this.$emit("cancel");
  }
  private getOptions() {
    return ["舌", "面", "目", "掌", "脉", "耳穴", "四诊"];
  }
  private sure() {
    let array: any = [];
    this.data.forEach((ele: any) => {
      if (ele["数量"]) {
        array.push(ele);
      }
    });
    if (array.length > 0) {
      this.$emit("change", this.data);
    } else {
      this.$message.warning("请选择习题分类和抽取数量");
    }
  }
  private getNum() {
    GetTemNum(this).then((res: any) => {
      this.numData = res;
    });
  }
}
